(function () {
  if (customElements.get('phone-consultation-booking')) return;

  var TIME_SLOTS = ['09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45'];
  var CONSULTATION_WEEKDAY = 2;
  var MIN_ADVANCE_HOURS = 24;
  var MAX_ADVANCE_DAYS = 14;

  var HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-01', '2026-05-14', '2026-05-25', '2026-06-04', '2026-10-03', '2026-11-01', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-05-27', '2027-10-03', '2027-11-01', '2027-12-25', '2027-12-26',
    '2028-01-01', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-25', '2028-06-05', '2028-06-15', '2028-10-03', '2028-11-01', '2028-12-25', '2028-12-26'
  ];

  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  var TEXT = {
    loading: 'Lade Verfügbarkeit...',
    loadError: 'Fehler beim Laden der Verfügbarkeit.',
    requiredFields: 'Bitte fülle alle Pflichtfelder aus.',
    missingSlot: 'Bitte wähle ein Datum und eine Uhrzeit aus.',
    submitError: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    sending: 'Wird gesendet...'
  };

  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  function toISODate(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function formatDate(date) {
    return 'Dienstag, ' + date.getDate() + '. ' + MONTHS[date.getMonth()] + ' ' + date.getFullYear();
  }

  function formatTime(time) {
    return time.replace(/^0/, '');
  }

  function getConsultationDays() {
    var days = [];
    var now = new Date();
    var minDate = new Date(now.getTime() + MIN_ADVANCE_HOURS * 60 * 60 * 1000);
    var maxDate = new Date(now);
    maxDate.setDate(maxDate.getDate() + MAX_ADVANCE_DAYS);
    maxDate.setHours(23, 59, 59, 999);

    var current = new Date(now);
    current.setHours(0, 0, 0, 0);

    while (current <= maxDate) {
      if (current.getDay() === CONSULTATION_WEEKDAY && current >= minDate && HOLIDAYS.indexOf(toISODate(current)) === -1) {
        days.push(new Date(current));
      }
      current.setDate(current.getDate() + 1);
    }

    return days;
  }

  class PhoneConsultationBooking extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.flyout = this.closest('.flyout');
      this.subtitle = this.flyout.querySelector('.flyout__subtitle');
      this.defaultSubtitle = this.subtitle ? this.subtitle.textContent : '';
      this.steps = this.querySelectorAll('[data-step]');
      this.daysList = this.querySelector('[data-days]');
      this.timesGroup = this.querySelector('[data-times-group]');
      this.timesList = this.querySelector('[data-times]');
      this.continueButton = this.querySelector('[data-continue]');
      this.form = this.querySelector('[data-step="form"]');
      this.fields = this.form.querySelectorAll('[data-field]');
      this.error = this.querySelector('[data-error]');
      this.submitButton = this.querySelector('[data-submit]');
      this.submitLabel = this.querySelector('[data-submit-label]');
      this.defaultSubmitLabel = this.submitLabel.textContent;

      this.continueButton.addEventListener('click', this.showForm.bind(this));
      this.querySelector('[data-back]').addEventListener('click', this.showSelection.bind(this));
      this.form.addEventListener('input', this.updateSubmitButton.bind(this));
      this.form.addEventListener('submit', this.submit.bind(this));

      document.querySelectorAll('[data-flyout-trigger="' + this.flyout.id + '"]').forEach(function (trigger) {
        trigger.addEventListener('click', this.reset.bind(this));
      }, this);

      this.reset();
    }

    reset() {
      this.resetSelection();
      this.showSelection();
    }

    showStep(name) {
      this.steps.forEach(function (step) {
        step.hidden = step.dataset.step !== name;
      });
    }

    showSelection() {
      this.showStep('select');
      this.setSubtitle(this.defaultSubtitle);
    }

    showForm() {
      if (!this.selectedDate || !this.selectedTime) return;
      this.showStep('form');
      this.setSubtitle('Termin: ' + formatDate(this.selectedDate) + ' um ' + formatTime(this.selectedTime) + ' Uhr');
      this.showError('');
      this.updateSubmitButton();
      this.fields[0].focus();
    }

    setSubtitle(text) {
      if (this.subtitle) this.subtitle.textContent = text;
    }

    resetSelection() {
      this.selectedDate = null;
      this.selectedDateISO = null;
      this.selectedTime = null;
      this.availabilityRequest = (this.availabilityRequest || 0) + 1;
      this.timesGroup.hidden = true;
      this.timesList.innerHTML = '';
      this.renderDays();
      this.updateContinueButton();
    }

    renderDays() {
      var self = this;
      this.daysList.innerHTML = '';

      getConsultationDays().forEach(function (date) {
        var button = self.createOption(formatDate(date));
        button.dataset.date = toISODate(date);
        button.addEventListener('click', function () {
          self.selectDay(button);
        });
        self.daysList.appendChild(button);
      });
    }

    selectDay(button) {
      this.markPressed(this.daysList, button);
      this.selectedDateISO = button.dataset.date;
      this.selectedDate = new Date(this.selectedDateISO + 'T12:00:00');
      this.selectedTime = null;
      this.updateContinueButton();
      this.fetchAvailability(this.selectedDateISO);
    }

    fetchAvailability(dateISO) {
      var self = this;
      var request = ++this.availabilityRequest;

      this.timesGroup.hidden = false;
      this.showTimesStatus(TEXT.loading);

      fetch(this.dataset.availabilityUrl + '?date=' + encodeURIComponent(dateISO))
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          if (request !== self.availabilityRequest) return;
          self.renderTimes((data && data.slots) || {});
        })
        .catch(function (error) {
          if (request !== self.availabilityRequest) return;
          console.error('[PhoneConsultation] Availability fetch error:', error);
          self.showTimesStatus(TEXT.loadError);
        });
    }

    showTimesStatus(text) {
      this.timesList.innerHTML = '';
      var status = document.createElement('p');
      status.className = 'phone-consultation__status';
      status.textContent = text;
      this.timesList.appendChild(status);
    }

    renderTimes(slots) {
      var self = this;
      this.timesList.innerHTML = '';

      TIME_SLOTS.forEach(function (time) {
        var available = slots[time] ? slots[time].available : 0;
        var button = self.createOption(formatTime(time));
        button.dataset.time = time;

        if (!(available > 0)) {
          button.disabled = true;
        } else {
          button.addEventListener('click', function () {
            self.markPressed(self.timesList, button);
            self.selectedTime = time;
            self.updateContinueButton();
          });
        }

        self.timesList.appendChild(button);
      });
    }

    createOption(label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ds-option';
      button.setAttribute('aria-pressed', 'false');
      button.textContent = label;
      return button;
    }

    markPressed(list, selected) {
      list.querySelectorAll('.ds-option').forEach(function (option) {
        option.setAttribute('aria-pressed', option === selected ? 'true' : 'false');
      });
    }

    updateContinueButton() {
      this.continueButton.disabled = !this.selectedDate || !this.selectedTime;
    }

    getValues() {
      var values = {};
      this.fields.forEach(function (field) {
        values[field.name] = field.value.trim();
      });
      return values;
    }

    hasEmptyField() {
      var values = this.getValues();
      return Object.keys(values).some(function (name) {
        return !values[name];
      });
    }

    updateSubmitButton() {
      this.submitButton.disabled = this.submitting || this.hasEmptyField();
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    submit(event) {
      var self = this;
      event.preventDefault();

      if (this.submitting) return;

      if (this.hasEmptyField()) {
        this.showError(TEXT.requiredFields);
        return;
      }

      if (!this.selectedDateISO || !this.selectedTime) {
        this.showError(TEXT.missingSlot);
        return;
      }

      var values = this.getValues();
      var bookingData = {
        customer_name: values.name,
        customer_phone: values.phone,
        customer_email: values.email,
        requested_date: this.selectedDateISO,
        requested_time: this.selectedTime,
        topic: values.topic
      };

      this.submitting = true;
      this.showError('');
      this.submitLabel.textContent = TEXT.sending;
      this.updateSubmitButton();

      fetch(this.dataset.bookingUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.success) throw new Error((data && data.message) || 'Unknown error');
          self.showConfirmation();
        })
        .catch(function (error) {
          console.error('[PhoneConsultation] Booking error:', error);
          self.showError(TEXT.submitError);
        })
        .finally(function () {
          self.submitting = false;
          self.submitLabel.textContent = self.defaultSubmitLabel;
          self.updateSubmitButton();
        });
    }

    showConfirmation() {
      this.showStep('confirmation');
      this.form.reset();
    }
  }

  customElements.define('phone-consultation-booking', PhoneConsultationBooking);
})();
